/**
 * mulberry32 — tiny, fast, seedable PRNG.
 * Determinism matters: given a seed + the same weather inputs + the same dt
 * sequence, the engine must produce an identical note stream (see tests).
 */
export function mulberry32(seed: number): () => number {
  let a = seed >>> 0;
  return function next(): number {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
